import { Map, Record } from 'immutable';

import type {
  BetEntity as BetEntityState,
  StakeEntity as StakeEntityState,
} from './types';

export const StakeEntity = Record<StakeEntityState>(
  {
    id: 0,
    matchId: 0,
    type: undefined,
    isOpen: true,
    params: Map(),
    names: Map(),
    bets: Map(),
  },
  'StakeEntity',
);

export const BetEntity = Record<BetEntityState>(
  {
    id: 0,
    stakeId: 0,
    matchId: 0,
    type: undefined,
    key: undefined,
    price: undefined,
    isOpen: true,
    names: Map(),
  },
  'BetEntity',
);
